/**
 * Accessibility helpers — focus rings, screen-reader text, keyboard hints.
 */

export const focusUtils = {
  /** Standard focus ring — primary color, 2px offset. */
  ring: 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
  /** Inset ring for elements inside dense surfaces (sidebar items, table rows). */
  ringInset: 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary',
  /** Subtle ring for secondary controls. */
  ringSubtle: 'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-400 focus-visible:ring-offset-1',
} as const;

/** Visually hidden — accessible to screen readers only. */
export const srOnly = 'sr-only';

/** Common ARIA bindings for dialog open/close. */
export const dialogA11y = {
  triggerProps: { 'aria-haspopup': 'dialog' as const },
} as const;
